import { cleanUpObjRecursive } from "@utils/helpers";
import { Route } from "@utils/search/routing/@types/route.types";
import { mapToRouteEntries } from "@utils/search/routing/configurationToUrl/configurationToRouteEntries";
import { getRoutePrefix } from "@utils/search/routing/routing.utils";

import { SearchConfiguration } from "@redux/modules/value/search/search.types";

const configurationToRoute = (
    configuration: SearchConfiguration,
    ignoreQuery: boolean,
): Route =>
    cleanUpObjRecursive(
        configuration.components.reduce(
            (route, componentConfiguration) => {
                const prefix = getRoutePrefix(componentConfiguration.component);
                if (!prefix) return route;

                return {
                    ...route,
                    ...Object.fromEntries(
                        mapToRouteEntries(componentConfiguration, prefix) ?? [],
                    ),
                };
            },
            {
                q: ignoreQuery ? undefined : configuration?.query,
            },
        ),
    );

export { configurationToRoute };
